import * as React from 'react';

import moment from 'moment';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {FooterBar} from 'shells/modal/footer-bar';
import {Modal} from 'shells/modal/modal';
import {roundTimeToNextQuarter} from 'shells/select-time-picker/helpers';

import type {CampaignType} from 'nutshell-graphql-types';

import {ScheduleView} from './schedule-view';

import styles from './prepare-to-send-modal.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    scheduledTime: number | null | undefined;
    type: CampaignType;
    onSchedule: (arg1: moment.Moment) => Promise<any>;
    onUnschedule: () => Promise<any>;
};

export function RescheduleEditionModal(props: Props) {
    const [isScheduling, setIsScheduling] = React.useState<boolean>(false);
    const [scheduledDate, setScheduledDate] = React.useState<moment.Moment>(
        roundTimeToNextQuarter(props.scheduledTime ? moment.unix(props.scheduledTime) : moment())
    );

    const onCloseModal = () => {
        setIsScheduling(false);
        props.onClose();
    };

    return (
        <Modal
            headerText={`Reschedule this ${props.type === 'NEWSLETTER' ? 'edition' : 'broadcast'}`}
            isOpen={props.isOpen}
            onClose={onCloseModal}
            preventBodyScroll={true}
            maxHeight={600}
        >
            <div className={styles.container}>
                <ScheduleView
                    scheduledDate={scheduledDate}
                    setScheduledDate={setScheduledDate}
                    onUnschedule={() => {
                        return props.onUnschedule().then(() => {
                            onCloseModal();
                        });
                    }}
                    type={props.type}
                />
            </div>
            <FooterBar
                left={
                    <Button variant='text' size='big' onClick={onCloseModal}>
                        Cancel
                    </Button>
                }
                right={
                    <SaveButton
                        type='button'
                        // @ts-expect-error
                        onClick={() => {
                            setIsScheduling(true);
                            props.onSchedule(scheduledDate).then(() => {
                                setIsScheduling(false);
                            });
                        }}
                        buttonText='Update'
                        savingText='Scheduling'
                        successText='Scheduled!'
                        onClearSaveComplete={() => {
                            onCloseModal();
                        }}
                        isSaving={isScheduling}
                        saveCompleteTimeout={1000}
                    />
                }
            />
        </Modal>
    );
}
